/* eslint complexity: 0 */

export default (state = {}, action) => {
    switch (action.type) {
        case 'SET_TRUSTPILOT':
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};
